import { render, staticRenderFns } from "./applyAdmin.vue?vue&type=template&id=7b130c6a&scoped=true"
import script from "./applyAdmin.vue?vue&type=script&lang=js"
export * from "./applyAdmin.vue?vue&type=script&lang=js"
import style0 from "./applyAdmin.vue?vue&type=style&index=0&id=7b130c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b130c6a",
  null
  
)

export default component.exports